import React from "react";
import styled from "styled-components";
import { Users, UserCheck, ShieldOff, Trash2 } from "lucide-react";
import type { ClientStats } from "./clients-types";

const StatsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  margin-bottom: 12px;
`;

const Card = styled.div<{ $color: string }>`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  background: white;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
`;

const IconWrap = styled.div<{ $bg: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  background: ${(p) => p.$bg};
  flex-shrink: 0;
`;

const CardContent = styled.div`
  display: flex;
  flex-direction: column;
`;

const CardValue = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: #202020;
  line-height: 1.2;
`;

const CardLabel = styled.div`
  font-size: 12px;
  color: #666;
`;

const CardSub = styled.div`
  font-size: 11px;
  color: #999;
  margin-top: 2px;
`;

interface Props {
  stats: ClientStats | null;
}

export const StatsCards: React.FC<Props> = ({ stats }) => {
  if (!stats) return null;

  return (
    <StatsRow>
      <Card $color="#1976d2">
        <IconWrap $bg="#e3f2fd">
          <Users size={18} color="#1976d2" />
        </IconWrap>
        <CardContent>
          <CardValue>{stats.total}</CardValue>
          <CardLabel>Всего</CardLabel>
          <CardSub>
            +{stats.today} сегодня / +{stats.week} неделя / +{stats.month} месяц
          </CardSub>
        </CardContent>
      </Card>

      <Card $color="#2e7d32">
        <IconWrap $bg="#e8f5e9">
          <UserCheck size={18} color="#2e7d32" />
        </IconWrap>
        <CardContent>
          <CardValue>{stats.active}</CardValue>
          <CardLabel>Активных</CardLabel>
        </CardContent>
      </Card>

      <Card $color="#e65100">
        <IconWrap $bg="#fff3e0">
          <ShieldOff size={18} color="#e65100" />
        </IconWrap>
        <CardContent>
          <CardValue>{stats.blocked}</CardValue>
          <CardLabel>Заблокированных</CardLabel>
        </CardContent>
      </Card>

      <Card $color="#c62828">
        <IconWrap $bg="#ffebee">
          <Trash2 size={18} color="#c62828" />
        </IconWrap>
        <CardContent>
          <CardValue>{stats.deleted}</CardValue>
          <CardLabel>Удалённых</CardLabel>
        </CardContent>
      </Card>
    </StatsRow>
  );
};
